import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=777bb868&scoped=true"
import script from "./HelpView.vue?vue&type=script&lang=js"
export * from "./HelpView.vue?vue&type=script&lang=js"
import style0 from "./HelpView.vue?vue&type=style&index=0&id=777bb868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777bb868",
  null
  
)

export default component.exports